import { Box, Typography } from '@material-ui/core'
import i18n from '../../../i18nextInitiator'

const t = i18n.getFixedT('fa', 'orderPage')

const IntercityMessage = () => {
	return (
		<Box
			sx={{
				display: 'flex',
				borderRadius: '6px',
				padding: '15px',
			}}>
			<Typography
				style={{
					fontSize: '16px',
					fontWeight: 500,
				}}
				color='#212529'>
				{t('intercityMessage')}
			</Typography>
		</Box>
	)
}

export default IntercityMessage
